import i18n from "@/i18n";
export const dataDetailTable = () => {
    return {
        columns: [
            {
                colId: "date",
                header: i18n.t("zhiji.common.date"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "visitTimes",
                header: i18n.t("zhiji.overview.visitTimes"),
                type: "Text",
                width: "6%"
            },
            {
                colId: "visitCount",
                header: i18n.t("zhiji.overview.visitCount"),
                type: "Text",
                width: "6%"
            },
            {
                colId: "questionsNum",
                header: i18n.t("zhiji.overview.questionsNum"),
                type: "Text",
                width: "6%"
            },
            {
                colId: "questionCount",
                header: i18n.t("zhiji.overview.questionCount"),
                type: "Text",
                width: "6%"
            },
            {
                colId: "enterQuesNum",
                header: i18n.t("zhiji.overview.enterQuesNum"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "inputQuesRate",
                header: i18n.t("zhiji.overview.inputQuesRate"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "inputQuesCount",
                header: i18n.t("zhiji.overview.inputQuesCount"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "replyRate",
                header: i18n.t("zhiji.overview.replyRate"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "satisfaction",
                header: i18n.t("zhiji.overview.satisfaction"),
                type: "Text",
                width: "10%"
            }
        ],
        pageLength: 10,
        pageLengthRank: [10, 20, 30]
    };
};
export const labourDataTable = () => {
    return {
        columns: [
            {
                colId: "date",
                header: i18n.t("zhiji.common.date"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "sessionNum",
                header: i18n.t("zhiji.overview.sessionNum"),
                type: "Text",
                width: "8%"
            },
            {
                colId: "ticketNum",
                header: i18n.t("zhiji.overview.ticketNum"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "ticketRate",
                header: i18n.t("zhiji.overview.ticketRate"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "artificialNum",
                header: i18n.t("zhiji.overview.artificialNum"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "artificialRate",
                header: i18n.t("zhiji.overview.artificialRate"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "interceptRate",
                header: i18n.t("zhiji.overview.interceptRate"),
                type: "Text",
                width: "10%"
            }
        ],
        pageLength: 10,
        pageLengthRank: [10, 20, 30]
    };
};
